import { render, staticRenderFns } from "./VueSimpleAccordion2.vue?vue&type=template&id=6799153c"
import script from "./VueSimpleAccordion2.vue?vue&type=script&lang=js"
export * from "./VueSimpleAccordion2.vue?vue&type=script&lang=js"
import style0 from "./VueSimpleAccordion2.vue?vue&type=style&index=0&id=6799153c&prod&lang=postcss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports